<!--
 * A Vue component for creating domains through modal.
 * This component accepts a pattern to test the e-mail address against.
 *
 * Dependencies
 * ==========
 * DomainDetail.vue component
 *
 * Properties
 * ==========
 * - launchModal -
 * Setting this property, triggers showDomainModal function.
 * - selectedImageType -
 * The selected image type to create.
 * - organizationId -
 * The selected organization id.
 * - overviewSelection -
 * Shows the bitmap overview table
 *
 * Events
 * ==========
 * - modal-domain-saved -
 * This event sends the created domain object to the subscriber.
 *
 * Usage
 * ==========
 * -In your paren component, create a boolean variable.
 * To luncht the modal, set the value of the boolean variable.
 * The value of boolean variable needs to be changed in order to trigger the watch function.
 *
-->
<template>
    <div>
        <b-modal no-close-on-esc no-close-on-backdrop
                 id="addbitmap"
                 size="lg"
                 hide-footer
                 hide-header>
            <bitmaps-select-overview v-show="bitmapOverview"
                                     :displayedInModal="true"
                                     @select-bitmap-saved="$_onSavedBitmap"
                                     @select-bitmap-cancel="$_hideModal"
                                     @select-bitmap-add="$_addNewBitmap">
            </bitmaps-select-overview>
            <bitmaps-detail v-show="!bitmapOverview"
                            :selectedImageType="imageType"
                            :displayedInModal="true"
                            @add-bitmap-cancel="$_onCancelAddBitmap"
                            :organizationId="organizationId"
                            @add-bitmap-saved="$_onSavedBitmap">
            </bitmaps-detail>
        </b-modal>
    </div>
</template>

<script>
    import { AVAILABLE_LOGO_TYPE } from '../../constants';
    import BitmapsDetail from './BitmapsDetail.vue';
    import BitmapsSelectOverview from './BitmapsSelectOverview.vue';

    export default {
        name: 'add-bitmap-modal',
        components: {
            'bitmaps-detail': BitmapsDetail,
            'bitmaps-select-overview': BitmapsSelectOverview
        },

        props: {
            launchModal: { type: Boolean, default: false },
            selectedImageType: { type: Number, default: -1 },
            organizationId: { type: Number, default: -1 },
            overviewSelection: { type: Boolean, default: false }
        },

        data() {
            return {
                imageType: this.selectedImageType,
                bitmapOverview: this.overviewSelection
            };
        },

        methods: {
            showAddImageModal() {
                this.$bvModal.show('addbitmap');
            },

            $_addNewBitmap() {
                this.imageType = AVAILABLE_LOGO_TYPE[2].value;
                this.bitmapOverview = false;
            },

            $_hideModal() {
                this.$bvModal.hide('addbitmap');
            },

            $_onCancelAddBitmap() {
                if (this.overviewSelection) {
                    this.bitmapOverview = true;
                } else {
                    this.$_hideModal();
                }
            },

            $_onSavedBitmap(data) {
                this.$emit('modal-bitmap-saved', data);
                this.$_hideModal();
            }
        },

        watch: {
            launchModal() {
                this.showAddImageModal();
            },

            selectedImageType(newValue) {
                this.imageType = newValue;
            }
        }
    };
</script>
